// 自定义字段类型
export const CUSTOM_TYPES = {
  NUMBER: 0, // 数值
  IMAGE: 1, // 图片
  TIME: 2, // 时间
  TIME_RANGE: 3, // 时间范围
  SELECT: 4, // 选项
  TEXT: 5, // 单行文本
  TEXTAREA: 6, // 多行文本
  TAG: 7, // 标签
  SINGLE_CHOICE: 8, // 单选
  SELECT_USER: 9 // 负责人
};

// 几个需要特殊处理的字段
export const FIELD_KEY_MAP = {
  LEVEL: 'level_id', // 讲师级别
  LEVEL_NAME: 'level_name', // 讲师级别名称
  CATALOG: 'catalog_id', // 讲师分类
  CATALOG_NAME: 'catalog_name', // 讲师分类名称
  TAG: 'tag_info', // 个人标签
  TAG_NAME: 'tag_name', // 个人标签名称
  SEX: 'sex', // 性别
  PHONE: 'phone', // 手机号码
  NAME: 'fullname', // 姓名
  REC_VAL: 'rec_val', // 推荐系数
  COST: 'cost', // 课时费
  AVATAR: 'avatar', // 头像
  AREA_CODE: 'area_code', // 区号
  DIRECTORS: 'directors', // 负责人
  DESCRIPTION: 'description', // 描述
  TAKE_OFFICE_DATE: 'take_office_date' // 任职日期
};
